// extracted by mini-css-extract-plugin
export default {"wrapper":"tariff-fail-message_wrapper__bwd98","message":"tariff-fail-message_message__ZBFHk"};